import React, { useState, useContext } from 'react';
import './steps.css';

import { UtilContext } from "../../context/UtilContext";
import { GLOBAL_LANGUAGE } from "../../language/language";
import ButtonNext from '../../components/button/ButtonWhite'
import { codePhones } from "../../utils/phonesCode.js";

import { ReactComponent as NO_CHECK } from '../../assets/IconsColurs/IconsGeneral/noCheck.svg';
import { ReactComponent as CHECK } from '../../assets/IconsColurs/IconsGeneral/checkNew.svg';
import Logo from "../../assets/logos/LogoColurs.png";
import { ReactComponent as NEXT } from '../../assets/IconsColurs/IconsGeneral/chevronRight.svg';


/* const steps = [
    "Información de la empresa",
    "Sector económico",
    "Información administrativa",
    "Beneficiarios finales",
    "Declaración y autorización",
    "Documentos para estudios",
    "Resumen"
];
 */
const StepProgress = ({ setPaso, paso, StepProgress, changeStep, onClickFinal, loading }) => {
    const { language } = useContext(UtilContext);
    const t = GLOBAL_LANGUAGE[language] || GLOBAL_LANGUAGE.es;
    const steps = GLOBAL_LANGUAGE[language].steps.titles;

    const stepConvertido = {
        ONE: 1,
        TWO: 2,
        THREE: 3,
        FOUR: 4,
        FIVE: 5,
        SIX: 6,
        SEVEN: 7,
    };

    const convertedStep = stepConvertido[StepProgress];

    const handleStepClick = (index) => {
        if (index + 1 <= convertedStep) {
            changeStep(index + 1);
        }
    };

    const progressPercentage = ((paso - 1) / (steps.length - 1)) * 100;

    return (
        <div className="h-full w-full bg-[#1a1b22] pl-0 pr-3 sm:pr-4 md:pr-6 pt-3 sm:pt-4 md:pt-6 flex flex-col">
            {/* Header */}
            <div className='w-full flex flex-col gap-3 sm:gap-5 mb-4 sm:mb-6 px-4 sm:px-6'>
                <img src={Logo} className="w-6 h-6 sm:w-8 sm:h-8" alt="Logo" />
                <div className='flex items-center justify-between'>
                    <div className='flex items-center'>
                        <h2 className="text-white font-brico text-base sm:text-lg md:text-2xl">
                            {GLOBAL_LANGUAGE[language].steps.label_current_step} {paso} / {steps.length}
                        </h2>
                    </div>
                    <div className='flex items-center justify-center w-6 h-6 sm:w-7 sm:h-7 rounded-full'>
                        <img
                            className='w-5 h-5 sm:w-6 sm:h-6'
                            src={language == "es" ? codePhones.es[2].flag : codePhones.es[6].flag}
                            alt={``}
                        />
                    </div>
                </div>
            </div>

            {/* Progress Bar */}
            <div className="w-full px-4 sm:px-6">
                <div className="w-full bg-[#2b2a32] h-1.5 rounded-full mb-6">
                    <div
                        className="h-full bg-white rounded-full transition-all duration-500 ease-in-out"
                        style={{ width: `${progressPercentage}%` }}
                    />
                </div>
            </div>

            {/* Container for Steps List and Button */}
            <div className="flex flex-col flex-1">
                {/* Steps List with limited height */}
                <div className="flex-1 overflow-y-auto px-4 sm:px-6">
                    <ul className="space-y-2 sm:space-y-4">
                        {steps.map((step, index) => (
                            <React.Fragment key={index}>
                                <li
                                    onClick={() => handleStepClick(index)}
                                    className={`flex items-center gap-2 sm:gap-3 p-2 sm:p-3 rounded-lg cursor-pointer transition-all
                                        ${index + 1 <= convertedStep ? 'hover:bg-[#2b2a32]' : 'cursor-not-allowed opacity-50'}
                                        ${index + 1 === paso ? 'bg-[#2b2a32]' : ''}`}
                                >
                                    <div className="flex-shrink-0">
                                        {index + 1 < paso ? (
                                            <CHECK className="w-5 h-5 sm:w-6 sm:h-6 text-white" />
                                        ) : (
                                            <NO_CHECK className={`w-5 h-5 sm:w-6 sm:h-6 ${index + 1 === paso ? 'text-white' : 'text-gray-500'}`} />
                                        )}
                                    </div>
                                    <span className={`text-xs sm:text-sm md:text-base ${index + 1 === paso ? 'text-white' : 'text-gray-400'}`}>
                                        {step}
                                    </span>
                                </li>
                                {/* Insert button after the last step */}
                                {index === steps.length - 1 && StepProgress === "SEVEN" && (
                                    <div className="mt-2">
                                        <ButtonNext
                                            label={t.steps7.label_button_next}
                                            Icon={NEXT}
                                            onClick={onClickFinal}
                                            loading={loading}
                                            className="w-full"
                                        />
                                    </div>
                                )}
                            </React.Fragment>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default StepProgress;
